import React, { FC, useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import TRANSLATION from 'components/twilio/translations';
import { COLORS } from '../../constants';
import UserNameText from '../styled/UserNameText';
import { ChatCloseButton } from '../CommonChatButtons';
import ChatHeaderContainer from '../styled/ChatHeaderContainer';
import ChatBellButton from '../ChatBellButton';

const MobileChatHeaderContainer = styled(ChatHeaderContainer)`
  border-radius: 0;
`;

const MobileChatHeader: FC = () => {
  const { t } = useTranslation();
  const nameComponent = useMemo(() => (
    <UserNameText margin="0 16px 0 16px" display="flex" flexGrow={1} justifyContent="center">
      {t(...TRANSLATION.COMMON.CHAT)}
    </UserNameText>
  ), [t]);

  return (
    <MobileChatHeaderContainer id="mobile-chat-header">
      <ChatCloseButton id="mobile-chat-header-close-button" iconColor={COLORS.WHITE} />
      {nameComponent}
      <ChatBellButton iconColor={COLORS.WHITE} />
    </MobileChatHeaderContainer>
  );
};

export default MobileChatHeader;
